<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="title">
            {{ 'integration.trigger-condition-logic.title' | translate: { name: data.condition.name } }}
        </div>
        <mat-icon class="icon" svgIcon="close" (click)="close(undefined)"></mat-icon>
    </div>
    <div class="main">
        <div class="condition-logic">
            <div class="data-name">
                {{ 'integration.trigger-condition-logic.logic.text' | translate }}
            </div>
            {{
                data.condition.operator
                    ? data.condition.operator
                    : ('integration.trigger-condition-logic.operator.none' | translate)
            }}
        </div>
        <div class="logic-item" *ngFor="let matrixChannel of matrixChannelList; let i = index">
            <div class="logic-name">
                {{ matrixChannel?.channel?.opsData?.tag + ' ' + matrixChannel?.channel?.opsData?.name }}
            </div>
            {{ getLogicDataToText(matrixChannel) }}
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>
